import React from 'react'
import GeneratedObject from '../../GeneratedObject'
import { getSocket, updateSocket } from '../utils/taskData'
import { instantiateObjectAndAddToRtSocket } from '../utils/api'

export const OpenSocketPanel = ({
    rtTask,
    dtTask,
    setRtTaskData,
    rtSocketId,
}) => {
    const rtSocket = getSocket(rtTask, rtSocketId)
    const objectId = rtSocket ? rtSocket.object_id : null
    const handleCreateObject = () => {
        instantiateObjectAndAddToRtSocket(rtTask.id, rtSocket.id).then((newObject) => {
            let newRtTask = {...rtTask}
            newRtTask = updateSocket(newRtTask, rtSocketId, {
                ...rtSocket,
                object_id: newObject.id
            })
            // console.log(newRtTask)
            setRtTaskData(newRtTask)
        }).catch((error) => {
            console.error(error)
        })
    }
    
    if (!objectId) {
        return (
            <div>
                <p>Socket not connected to any object</p>
                <button onClick={handleCreateObject}>
                    Create Object
                </button>
                <button>
                    Link Existing Object
                </button>
            </div>
        )
    }

    return (
        <GeneratedObject
            inputId={objectId}
        />
    )
}
